import React, { Suspense, lazy, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.scss";
import { ReactComponent as ThemeLightIcon } from "../../assets/ico/light.svg";
import { ReactComponent as ThemeDarkIcon } from "../../assets/ico/dark.svg";
import { useThemeMode } from "../../hooks/useThemeMode";

import Logo from "../../assets/img/logo.webp";

const Modal = lazy(() => import("../Modal/Modal"));
const Contact = lazy(() => import("../Contact/Contact"));

const Header = () => {
  const location = useLocation();
  const progressRef = useRef(null);
  const [activeSection, setActiveSection] = useState("");
  const [scrolled, setScrolled] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const { mode, setMode } = useThemeMode();

  const modeLabel = (current) =>
    current === "light" ? "Activer le thème sombre" : "Activer le thème clair";

  const handleContactClick = () => {
    setShowContact(true);
  };

  const handleCloseContact = () => {
    setShowContact(false);
  };

  useEffect(() => {
    let frame;
    const update = () => {
      const { scrollHeight, clientHeight } = document.documentElement;
      const progress = window.scrollY / Math.max(1, scrollHeight - clientHeight);
      if (progressRef.current) progressRef.current.style.transform = `scaleX(${progress})`;
      setScrolled(window.scrollY > 32);
      let section = "";
      if (location.pathname === "/") {
        ["cases-study", "about", "works"].forEach((id) => {
          const element = document.getElementById(id);
          if (element && element.getBoundingClientRect().top < window.innerHeight * 0.4) section = id;
        });
      }
      setActiveSection(section);
      frame = null;
    };
    const onScroll = () => { if (!frame) frame = requestAnimationFrame(update); };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [location.pathname]);

  useEffect(() => {
    const openContactModal = () => setShowContact(true);
    window.addEventListener("open-contact-modal", openContactModal);
    return () => {
      window.removeEventListener("open-contact-modal", openContactModal);
    };
  }, []);

  return (
    <div className="global">
      <nav className={`wrapper header ${scrolled ? "is-scrolled" : ""}`} aria-label="Main navigation">
        <div className="container">
          <Link to="/" className="logo-container" aria-label="Léo Frati — Home">
            <img
              src={Logo}
              alt="Logo"
              loading="eager"
              fetchPriority="high"
              decoding="async"
              width="120"
              height="120"
            />
          </Link>

          <div className="nav-items">
            <ul>
              <li>
                <Link to="/#cases-study" aria-current={activeSection === "cases-study" ? "location" : undefined}>Case studies</Link>
              </li>
              <li>
                <Link to="/#about" aria-current={activeSection === "about" ? "location" : undefined}>About</Link>
              </li>
              <li>
                <Link to="/#works" aria-current={activeSection === "works" ? "location" : undefined}>Works</Link>
              </li>

              {/* <li className="ico">
                <Download />
                <a href={Resume} target="_blank" rel="noopener noreferrer">
                  Resume
                </a>
              </li> */}
            </ul>
          </div>

          <div className="reading-progress" aria-hidden="true"><span ref={progressRef} /></div>
          <div className="nav-btn">
            <div className="contact-container">
              <button
                type="button"
                onClick={handleContactClick}
                className="btn-primary"
              >
                Get in touch
              </button>
            </div>
            <button
              type="button"
              className="theme-toggle"
              data-mode={mode}
              onClick={() => setMode(mode === "light" ? "dark" : "light")}
              aria-label={modeLabel(mode)}
              title={modeLabel(mode)}
            >
              {mode === "light" ? (
                <ThemeLightIcon aria-hidden="true" focusable="false" />
              ) : (
                <ThemeDarkIcon aria-hidden="true" focusable="false" />
              )}
            </button>
          </div>
        </div>
      </nav>
      <Suspense fallback={null}>
        <Modal
          isOpen={showContact}
          onClose={handleCloseContact}
          chatHeader={{
            avatar: require("../../assets/img/leo.webp"),
            name: "Léo",
          }}
        >
          <Contact isOpen={showContact} />
        </Modal>
      </Suspense>
    </div>
  );
};

export default Header;
